var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"a-clipboard",on:{"click":_vm.copy}},[(!_vm.clicked)?_c('span',{ref:"val",staticClass:"a-clipboard__val"},[_vm._t("default")],2):_c('span',[_vm._v(_vm._s(_vm.$t('AddedToClipboard')))]),_vm._v(" "),_c('base-icon',{attrs:{"icon":"link"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }